import PROD_CONFIG from './config.production.json';
import LOCAL_CONFIG from './config.local.json';

let CONFIG = {
    ...LOCAL_CONFIG,
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL || LOCAL_CONFIG.apiBaseUrl,
    webBaseUrl: process.env.VUE_APP_WEB_BASE_URL || LOCAL_CONFIG.webBaseUrl
};

if (process.env.NODE_ENV === 'production') {
    const prodConfig = {
        ...PROD_CONFIG,
        featureToggles: {
            metricToleranceCheckEnabled: JSON.parse(PROD_CONFIG.featureToggles.metricToleranceCheckEnabled),
            inferMeterResetDatesEnabled: JSON.parse(PROD_CONFIG.featureToggles.inferMeterResetDatesEnabled),
            defectsEnabled: JSON.parse(PROD_CONFIG.featureToggles.defectsEnabled),
            brakeCheckEnabled: JSON.parse(PROD_CONFIG.featureToggles.brakeCheckEnabled)
        },
        tolerances: {
            completedAtHours: parseInt(PROD_CONFIG.tolerances.completedAtHours, 10),
            completedAtKilometres: parseInt(PROD_CONFIG.tolerances.completedAtKilometres, 10),
            completedAtDays: parseInt(PROD_CONFIG.tolerances.completedAtDays, 10),
            documentationOverdueReminderInDays: parseInt(PROD_CONFIG.tolerances.documentationOverdueReminderInDays, 10)
        },
      timers: {
          defectsRefreshMinutes: parseInt(PROD_CONFIG.timers.defectsRefreshMinutes, 10),
      }
    };

    CONFIG = prodConfig;
}

export default CONFIG;
